// extracted by mini-css-extract-plugin
module.exports = {"form-dialog":"Dialog_form-dialog__8vzEz"};